import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import {
  faTwitter,
  faFacebookF,
  faYoutube,
  faLinkedinIn,
  faInstagram,
} from "@fortawesome/free-brands-svg-icons";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";

const Footer = () => {
  const scrollToTop = (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      {/* ===== Footer Start ===== */}
      <div
        className="container-fluid text-light py-5 mt-5"
        style={{
          backgroundColor: "var(--heading)",
          color: "var(--white)",
        }}
      >
        <div className="container py-5">
          <div className="row g-5">
            {/* ===== Our Office ===== */}
            <div className="col-lg-3 col-md-6">
              <h4
                className="mb-4"
                style={{ color: "var(--secondary)", fontWeight: "700" }}
              >
                Our Office
              </h4>
              <p className="mb-2" style={{ color: "var(--white)" }}>
                <i className="fa fa-map-marker-alt me-3"></i>
                Gurgaon , Haryana
              </p>
              <p className="mb-2" style={{ color: "var(--white)" }}>
                <i className="fa fa-phone-alt me-3"></i>+91 7011468336
              </p>
              <p className="mb-2" style={{ color: "var(--white)" }}>
                <i className="fa fa-envelope me-3"></i>
                contact@sagfinancials.com
              </p>

              {/* Social Links */}
              <div className="d-flex pt-2 justify-content-center justify-content-md-start">
                {[
                  { icon: faInstagram, link: "https://www.instagram.com/finance.with.shepra/" },
                  { icon: faFacebookF, link: "https://www.facebook.com/share/1D2BYZrbo8/" },
                  { icon: faLinkedinIn, link: "https://www.linkedin.com/company/sag-financials/" },
                ].map(({ icon, link }, index) => (
                  <a
                    key={index}
                    href={link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-square rounded-circle me-2"
                    style={{
                      width: "40px",
                      height: "40px",
                      backgroundColor: "transparent",
                      border: "2px solid var(--secondary)",
                      color: "var(--white)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      transition: "all 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "var(--secondary)";
                      e.currentTarget.style.color = "var(--heading)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "transparent";
                      e.currentTarget.style.color = "var(--white)";
                    }}
                  >
                    <FontAwesomeIcon icon={icon} />
                  </a>
                ))}
              </div>

            </div>

            {/* ===== Services ===== */}
            <div className="col-lg-3 col-md-6">
              <h4
                className="mb-4"
                style={{ color: "var(--secondary)", fontWeight: "700" }}
              >
                Services
              </h4>
              <ul className="list-unstyled">
                {[
                  "Wealth & Goal Planning",
                  "Investment Solutions",
                  "Protection Planning",
                  "Tax Planning & Loan Advisory",
                ].map((service, i) => (
                  <li key={i}>
                    <a
                      href="/"
                      className="text-decoration-none d-block mb-2"
                      style={{
                        color: "var(--white)",
                        transition: "color 0.3s ease",
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.color = "var(--secondary)")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.color = "var(--white)")
                      }
                    >
                      {service}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* ===== Quick Links ===== */}
            <div className="col-lg-3 col-md-6">
              <h4
                className="mb-4"
                style={{ color: "var(--secondary)", fontWeight: "700" }}
              >
                Quick Links
              </h4>
              <ul className="list-unstyled">
                {[
                  { name: "About Us", path: "/about" },
                  { name: "Contact Us", path: "/contact" },
                  { name: "Our Services", path: "/services" },
                ].map((link, i) => (
                  <li key={i}>
                    <Link
                      to={link.path}
                      className="text-decoration-none d-block mb-2"
                      style={{
                        color: "var(--white)",
                        transition: "color 0.3s ease",
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.color = "var(--secondary)")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.color = "var(--white)")
                      }
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* ===== Newsletter ===== */}
            <div className="col-lg-3 col-md-6">
              <h4
                className="mb-4"
                style={{ color: "var(--secondary)", fontWeight: "700" }}
              >
                Newsletter
              </h4>
              <p className="small" style={{ color: "var(--white)" }}>
                Subscribe to get the latest updates and offers.
              </p>
              <div className="position-relative">
                <input
                  type="email"
                  className="form-control w-100 py-3 ps-4 pe-5"
                  placeholder="Your email"
                  style={{
                    borderColor: "var(--secondary)",
                    backgroundColor: "var(--white)",
                    color: "var(--text)",
                    borderRadius: "6px",
                  }}
                />
                <button
                  className="btn position-absolute top-0 end-0 mt-2 me-2 text-white"
                  style={{
                    backgroundColor: "var(--primary)",
                    border: "none",
                    borderRadius: "4px",
                    transition: "all 0.3s ease",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.backgroundColor = "var(--secondary)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.backgroundColor = "var(--primary)")
                  }
                >
                  SignUp
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ===== Copyright ===== */}
      <div
        className="container-fluid text-center text-white py-3"
        style={{
          backgroundColor: "var(--accent)",
          color: "var(--white)",
        }}
      >
        <p className="mb-0">
          &copy;{" "}
          <a
            href="/"
            className="text-white text-decoration-underline"
            style={{ color: "var(--secondary)" }}
          >
            SAG Financials
          </a>{" "}
          — All Rights Reserved.
        </p>
      </div>

      {/* ===== Back to Top ===== */}
      <button
        onClick={scrollToTop}
        className="btn rounded-circle position-fixed"
        style={{
          bottom: "20px",
          right: "20px",
          width: "45px",
          height: "45px",
          backgroundColor: "var(--primary)",
          color: "var(--white)",
          border: "none",
          boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
          transition: "all 0.3s ease",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = "var(--secondary)";
          e.currentTarget.style.color = "var(--dark)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = "var(--primary)";
          e.currentTarget.style.color = "var(--white)";
        }}
      >
        <FontAwesomeIcon icon={faArrowUp} />
      </button>
    </>
  );
};

export default Footer;
